<template>
  <b-form-group
    label="Cooperado"
    :state="state('selecaoCooperado')"
    invalid-feedback="O campo cooperado é obrigatório"
  >
    <multiselect
      label="name"
      track-by="name"
      :taggable="false"
      :allowEmpty="false"
      :options="cooperadoLkp"
      @input="emitirCooperado"
      v-model="selecaoCooperado"
      selected-label="Selecionado"
      placeholder="Selecione o cooperado"
      invalid-feedback="Campo obrigatório"
      deselect-label="Pressione Enter para remover"
      select-label="Pressione Enter para selecionar"
    >
      <span slot="noResult">Nenhum cooperado encontrado</span>
      <span slot="noOptions">Nenhum cooperado disponível</span>
    </multiselect>
  </b-form-group>
</template>

<script>
import Multiselect from "vue-multiselect";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [clienteRuralMixin],
  components: { Multiselect },
  data() {
    return {
      selecaoCooperado: null,
      disabledCooperado: false,
      cooperadoLkp: [],
      cdPessoa: null,
      sqUsuario: null,
      componentLoaded: false
    };
  },
  props: {
    submit: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Number,
      default: 0
    },
    value: {
      type: Object,
      default: null
    }
  },
  watch: {
    submit(val) {
      if (!this.componentLoaded || this.disabledCooperado) return;

      if (val) {
        this.$v.$touch();
      } else {
        this.$v.$reset();
      }
    },

    reset() {
      this.$v.$reset();
      this.selecaoCooperado = null;
      this.emitirCooperado();
    },

    value: {
      handler(newVal) {
        if (newVal && this.cooperadoLkp.length > 0) {
          const encontrado = this.cooperadoLkp.find(
            cooperado => cooperado.value === newVal.value
          );

          if (encontrado) {
            this.selecaoCooperado = encontrado;
          } else {
            this.selecaoCooperado = null;
          }
        } else if (newVal === null) {
          this.selecaoCooperado = null;
        }
      },
      immediate: true,
      deep: true
    }
  },

  computed: {
    quantidadeCooperados() {
      return this.cooperadoLkp.length;
    }
  },

  async created() {
    await this.buscarDados();
  },

  methods: {
    async buscarDados() {
      await this.getNomeRazaoUsuario();
      await this.buscarLkpCooperado();
      await this.verificarCooperado();

      // if (this.cooperadoLkp.length === 1) {
      //   this.disabledCooperado = true;
      // }
      if (this.value && this.cooperadoLkp.length > 0) {
        const encontrado = this.cooperadoLkp.find(
          cooperado => cooperado.value === this.value.value
        );
        if (encontrado) {
          this.selecaoCooperado = encontrado;
          this.$emit("cooperadoSelecionado", encontrado);
        }
      }

      if (this.selecaoCooperado !== null) {
        this.$emit("cooperadoSelecionado", this.selecaoCooperado);
      }

      this.componentLoaded = true;
    },
    async getNomeRazaoUsuario() {
      try {
        this.cdPessoa = this.$store.state.me?.cd_pessoa;
        this.sqUsuario = this.$store.state.me?.sq_usuario;
      } catch {
        this.logoutUser();
      }
    },
    async verificarCooperado() {
      if (this.cooperadoLkp.length <= 1) {
        const cooperadoEncontrado = this.cooperadoLkp.find(
          cooperado => cooperado.value === this.cdPessoa
        );

        if (cooperadoEncontrado) {
          this.selecaoCooperado = cooperadoEncontrado;
        } else {
          this.selecaoCooperado = null;
        }
      } else {
        this.selecaoCooperado = null;
      }

      return;
    },
    state(param) {
      if (!this.componentLoaded) return null;

      if (this.submit) {
        return !this.$v[param].$invalid;
      }

      return null;
    },

    emitirCooperado() {
      this.$emit("cooperadoSelecionado", this.selecaoCooperado ?? null);
      this.$emit("input", this.selecaoCooperado ?? null);
    }
  },
  validations: {
    selecaoCooperado: { required }
  }
};
</script>
